import * as ContentLinkNS from '../Models/ContentLink.js';
import StringUtils from '../Util/StringUtils.js';

export const ContentLink = ContentLinkNS.ContentLinkService
export const String = StringUtils;